import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PendingRequest =
  | 'signIn'
  | 'forgotPassword'
  | 'resetPassword'
  | 'sendInvite'
  | 'acceptInvite'
  | 'removeUserFromLab'
  | 'assignLabRole'
  | 'getLabUsers'
  | 'addUserToLab'
  | 'addUsersToLab'
  | 'updateUser'
  | 'getSeqeraPipelines'
  | 'getSeqeraRuns'
  | 'loadSeqeraPipeline'
  | 'loadSeqeraRun'
  | 'cancelSeqeraRun'
  | 'getOmicsWorkflows'
  | 'getOmicsRuns'
  | 'loadOmicsWorkflow'
  | 'loadOmicsRun'
  | 'cancelOmicsRun'
  | 'createOrg'
  | 'fetchOrgData'
  | 'editOrg'
  | 'createLab'
  | 'updateLab'
  | 'getLabs'
  | 'deleteLab'
  | 'fetchOrgLabs'
  | 'fetchUserLabs'
  | 'loadLabData'
  | `addUserToLabButton-${string}-${string}`
  | 'fetchS3Content'
  | 'loadRunReports'
  | 'editProfileDetails'
  | 'toggleOrgAdmin'
  | 'loadLabRuns'
  | 'updateDefaultOrg'
  | 'generateSampleSheet'
  | 'downloadSampleSheet'
  | `downloadHtmlFileButton-${string}`
  | 'switchOrg'
  | 'getBatchPipelines'
  | 'getBatchJobs'
  | 'loadBatchJob'
  | 'loadBatchPipeline'
  | 'loadUsageDashboard';

interface UiStoreState {
  pendingRequests: Record<string, boolean>;
  previousPageRoute: string;
  remountAppKey: number;

  isRequestPending: (val: PendingRequest) => boolean;
  anyRequestPending: (vals: PendingRequest[]) => boolean;
  setRequestPending: (val: PendingRequest) => void;
  setRequestComplete: (val: PendingRequest) => void;
  setPreviousPageRoute: (route: string) => void;
  incrementRemountAppKey: () => void;
  reset: () => void;
}

const initialState = {
  pendingRequests: {} as Record<string, boolean>,
  previousPageRoute: '',
  remountAppKey: 0,
};

export const useUiStore = create<UiStoreState>()(
  persist(
    (set, get) => ({
      ...initialState,

      isRequestPending: (val: PendingRequest) => !!get().pendingRequests[val],

      anyRequestPending: (vals: PendingRequest[]) => vals.some((val) => !!get().pendingRequests[val]),

      setRequestPending: (val: PendingRequest) =>
        set((state) => ({
          pendingRequests: { ...state.pendingRequests, [val]: true },
        })),

      setRequestComplete: (val: PendingRequest) =>
        set((state) => {
          const rest = { ...state.pendingRequests };
          delete rest[val];
          return { pendingRequests: rest };
        }),

      setPreviousPageRoute: (route: string) => set({ previousPageRoute: route }),

      incrementRemountAppKey: () => set((state) => ({ remountAppKey: state.remountAppKey + 1 })),

      reset: () => set({ ...initialState }),
    }),
    {
      name: 'uiStore',
      partialize: (state) => ({ previousPageRoute: state.previousPageRoute }),
    },
  ),
);
